import { gql, useMutation, useQuery } from "@apollo/client";

const INSPECTION_SYNC_STATUS = gql`
  query InspectionSyncStatus($projectId: String!) {
    inspectionSyncStatus(projectId: $projectId) {
      projectId
      lastSyncedAt
    }
  }
`;

const SYNC_PROJECT_INSPECTION_STATUS = gql`
  mutation SyncProjectInspectionStatus($projectId: String!) {
    syncProjectInspectionStatus(projectId: $projectId) {
      success
      message
    }
  }
`;

const SYNC_INSPECTION_TOPICS = gql`
  mutation SyncInspectionTopics($inspectionId: String!) {
    syncInspectionTopics(inspectionId: $inspectionId) {
      success
      message
    }
  }
`;

export function useInspectionSyncStatus(projectId: string | null | undefined) {
  const { data, loading, refetch } = useQuery<{
    inspectionSyncStatus: { projectId: string; lastSyncedAt: string | null };
  }>(INSPECTION_SYNC_STATUS, {
    variables: { projectId: projectId ?? "" },
    skip: !projectId,
    fetchPolicy: "cache-and-network",
    pollInterval: 60_000, // refresh label every minute
  });

  return {
    lastSyncedAt: data?.inspectionSyncStatus.lastSyncedAt ?? null,
    loading,
    refetch,
  };
}

export function useSyncProjectInspections() {
  const [mutate, { loading }] = useMutation(SYNC_PROJECT_INSPECTION_STATUS);
  return {
    loading,
    syncProject: async (projectId: string) => {
      const { data } = await mutate({ variables: { projectId } });
      return data?.syncProjectInspectionStatus;
    },
  };
}

export function useSyncInspectionTopics() {
  const [mutate, { loading }] = useMutation(SYNC_INSPECTION_TOPICS);
  return {
    loading,
    syncInspection: async (inspectionId: string) => {
      const { data } = await mutate({ variables: { inspectionId } });
      return data?.syncInspectionTopics;
    },
  };
}
